import { useMutation } from '@tanstack/react-query';
import {
  completeUpload,
  presignUpload,
  uploadProfilePhotoBytes,
  type PresignUploadInput,
} from '@nomiss/services';

export function usePresignProfilePhoto() {
  return useMutation({
    mutationFn: (input: PresignUploadInput) => presignUpload(input),
  });
}

export function useCompleteProfilePhotoUpload() {
  return useMutation({
    mutationFn: (mediaId: string) => completeUpload(mediaId),
  });
}

export function useUploadProfilePhotoBytes() {
  return useMutation({
    mutationFn: (input: {
      presign: Awaited<ReturnType<typeof presignUpload>>;
      bytes: ArrayBuffer | Blob;
      contentType: string;
    }) => uploadProfilePhotoBytes(input.presign, input.bytes, input.contentType),
  });
}
